export default __webpack_public_path__ + "static/media/Titan-Women-in-Business-Awards-Logo-Black.090f8809.png";